import React from 'react';
import BarGraph from '../Bar/BarGraph';

const GroupedBarGraph = (props) => <BarGraph grouped {...props} />;

export default GroupedBarGraph;
